import { Chapter } from "./Chapter";
import { EditLesson } from "./EditLesson";

export class Lesson {
    lesson: ILesson;
    chapter: Chapter;
    dom: HTMLAnchorElement;
    editHandler: EditLesson;
    contentSection: HTMLDivElement;
    constructor(data: ILesson, chapter: Chapter) {
      this.lesson = data;
      this.chapter = chapter;
      this.dom = document.createElement("a");
      this.contentSection = document.querySelector(
        "#content-section"
      ) as HTMLDivElement;
      this.configure();
      this.editHandler = new EditLesson(this);
      this.addEvents();
    }
    configure() {
      this.dom.href = "#";
      this.dom.classList.add("list-group-item", "list-group-item-action");
      const p = document.createElement("p");
      p.innerHTML = this.lesson.Title;
      const badge = document.createElement("span");
      badge.classList.add("badge", "text-bg-info");
      badge.innerHTML = this.lesson.Type;
      this.dom.appendChild(p);
      this.dom.appendChild(badge);
    }
    addEvents() {
      this.dom.onpointerup = () => {
        this.contentSection.innerHTML = "";
        this.contentSection.appendChild(this.editHandler.dom);
      };
    }
  }